import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CommentDataInterface } from 'src/app/types/comment-data.interface';
import { CommentInterface } from 'src/app/types/comment.interface';
import { environment } from '../../../../../src/environments/environment';
import { UserService } from '../../../user.service';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  private API_URL= environment.API_URL;
  private commentType= "";
  private url = `${this.API_URL}/blog-comments`;
  
  getComments(articleId: string): Observable<CommentDataInterface> {
    const url = `${this.API_URL}/blog-comments?filters[blog_post][id][$eq]=${articleId}&sort=updatedAt:DESC&populate=*`;
    return this.httpClient.get<CommentDataInterface>(url, {
      headers: { Authorization: `Bearer ${environment.API_TOKEN}` },
    });
  }  

  constructor(private httpClient: HttpClient, private user: UserService) { }

  createComment(
    text: string,
    articleId: string,
    parentId: string | null = null
  ): Observable<CommentInterface> {
    const currentUser = this.user.getUser();

    // 🔐 Safety check to ensure the user is logged in
    if (!currentUser || !currentUser.id) {
      throw new Error('User not found. Please log in.');
    }

    const userId = currentUser.id;

    return this.httpClient.post<any>(
      `${this.url}?populate=user,blog_post&sort=updatedAt:desc`,
      {
        data: {
          body: text,
          user: userId,
          blog_post: articleId,
          parentId: parentId ? parentId.toString() : parentId
        }
      },
      this.user.getAuthHeader()
    ).pipe(map(response => {
      return response.data as CommentInterface;
    }));
  }

  updateComment(id: string, text: string): Observable<CommentInterface> {

    return this.httpClient.put<any>(
      `${this.url}/${id}?populate=user,blog_post`,
      {
        data: {
            body: text,
        }
      },
      this.user.getAuthHeader()
    ).pipe(map(response => {
      return response.data as CommentInterface;
    }));
  }

  addLike(commentId: string, likes: number): Observable<CommentInterface> {

      return this.httpClient.put<any>(
        `${this.url}/${commentId}`,
      {
        "data": {
            likes: likes
        }
      },
      this.user.getAuthHeader()
      ).pipe(map(response => {
        return response.data as CommentInterface;
      }));
  }

  toggleLikeComment(commentId: string, userId: string, likedByUsers: number[]): Observable<CommentInterface> {
    const isAlreadyLiked = likedByUsers.includes(Number(userId));
  
    const updatedLikedBy = isAlreadyLiked
      ? likedByUsers.filter(id => id !== Number(userId)) // retirer
      : [...likedByUsers, Number(userId)];               // ajouter
  
      return this.httpClient.put<any>(
        `${this.url}/${commentId}?populate=user,blog_post,liked_by`,
        {
          data: {
            liked_by: updatedLikedBy,
            likes: updatedLikedBy.length // ✅ mettre à jour aussi le compteur
          }
        },
        this.user.getAuthHeader()        
    ).pipe(
      map(res => res.data as CommentInterface)
    );
  }
  
  

  deleteComment(id: string): Observable<{}> {
    return this.httpClient.delete(
      `${this.url}/${id}`,
      this.user.getAuthHeader()
     );
  }
}
